// Keep adding the sizes here as it when it comes in future.

// These are kept same as the ones in tmatter.
const MEDIUM = 'medium';
const SMALL = 'small';
const LARGE = 'large';
export const SIZE_TO_VAL = {
  [SMALL]: '4px',
  [MEDIUM]: '6px',
  [LARGE]: '8px'
};
export const SIZES = {
  SMALL,
  MEDIUM,
  LARGE
};